import { SYNAPSE_COMMISSION_CODE } from '../../../../Core.constants';

export const synapse = ({
  event,
  instances,
  origin: { commissionCode } = {},
  urlParams: { fingerprint } = {},
} = {}) => {
  if (commissionCode !== SYNAPSE_COMMISSION_CODE || !fingerprint) return;

  window.gtag('event', event, {
    chat_source: fingerprint.includes('whatsapp') ? 'whatsapp' : 'sarai',
    send_to: instances.map(({ idAnalytics } = {}) => idAnalytics),
  });
};
